/**
 * Model to hold a single report.
 */
export class Report {
    public static ID_RANKINGS: string = '3e879e82-4e56-a7b2-8a2b-3f1698c004f2';

    public id: string;
    public name: string;
    public isGlobal: boolean;
    public isTeam: boolean;

    public isRanking(): boolean {
        return this.id === Report.ID_RANKINGS;
    }

    public clone(): Report {
        const clone: Report = new Report();
        clone.id = this.id;
        clone.name = this.name;
        clone.isGlobal = this.isGlobal;
        clone.isTeam = this.isTeam;
        return clone;
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: any): Report {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.id = data.id;
        this.name = attrs.name;
        this.isGlobal = attrs.isGlobal;
        this.isTeam = attrs.isTeam;

        return this;
    }
}
